import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ansyn-tasks-form-page',
	templateUrl: './tasks-form-page.component.html',
	styleUrls: ['./tasks-form-page.component.less']
})
export class TasksFormPageComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}
